$(document).ready(function () {
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.custom_sercah"
  ).on("click", function () {
    setTimeout(function () {
      $(
        "input.form-field-input.live-search-form-field.serachinputactive.inputactive"
      ).focus();

    }, 300);
  });
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.for_mobile_csrty"
  ).on("click", function () {
    setTimeout(function () {
      $(
        "input.form-field-input.live-search-form-field.for_moble_csrt.serachinputactive.inputactive"
      ).focus();

    }, 300);
  });
  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.custom_sercah"
  ).on("click", function () {
    $(".nav_center_nikki").addClass("serachactive");
    $("input.form-field-input.live-search-form-field").addClass(
      "serachinputactive"
    );
    $("form.live-search-form.form-fields-inline input").addClass("inputactive");
    $("button.live-search-takeover-cancel").addClass("cancelactive");
    $(".live-search.hover_unique_csrty").addClass("liveserachactive");
  });
  $("button.live-search-takeover-cancel").on("click", function () {
    $("form.live-search-form.form-fields-inline input").removeClass(
      "inputactive"
    );
    $("button.live-search-takeover-cancel").removeClass("cancelactive");
    $(".nav_center_nikki").removeClass("serachactive");
    $("input.form-field-input.live-search-form-field").removeClass(
      "serachinputactive"
    );
    $(".live-search.hover_unique_csrty + .form-field.no-label").removeClass(
      "input_active"
    );
    $(".live-search.hover_unique_csrty").removeClass("liveserachactive");
  });

  $(
    "button.live-search-button.mdc-ripple-surface.mdc-ripple-upgraded.for_mobile_csrty"
  ).on("click", function () {
    $("input.form-field-input.live-search-form-field.for_moble_csrt").addClass(
      "serachinputactive"
    );
    $(
      "form.live-search-form.form-fields-inline.for_mobile_csrt input"
    ).addClass("inputactive");
    $("button.live-search-takeover-cancel.for_mobile_csrt").addClass(
      "cancelactive"
    );
    $(".live-search.hover_unique_csrty.for_mobile_csrty").addClass(
      "liveserachactive"
    );
  });


  $("input.form-field-input.live-search-form-field.serachinputactive").keypress(
    function (event) {
      if (event.which === 13) {
        $(
          "button.live-search-button.serach_ctyu.mdc-ripple-surface.mdc-ripple-upgraded"
        ).trigger("click");
      }
    }
  );

  $(".custom-model-main").removeClass("model-open");
  $(".productitem--swatches").mouseenter(function () {
    $(this)
      .children("form.productitem--swatches-container")
      .addClass("Show_variant_color");
  });
  $(".productitem--swatches").mouseleave(function () {
    $(this)
      .children("form.productitem--swatches-container")
      .removeClass("Show_variant_color");
  });


  $(".variant_field_csrty").mouseenter(function () {
    $(this)
      .children(
        "fieldset.options-selection__swatches.options-selection__swatches--color_swatch"
      )
      .addClass("desk_count_active");
  });

  $(".variant_field_csrty").mouseleave(function () {
    $(this)
      .children(
        "fieldset.options-selection__swatches.options-selection__swatches--color_swatch"
      )
      .removeClass("desk_count_active");
  });

  $(
    ".product-form__action-wrapper.own_product button.product-form--atc-button.own_addtoCart.mdc-ripple-surface.mdc-ripple-upgraded"
  ).css("max-width", "100%");
  $(".bundle-sec .bundle-grid").on("click", function () {
    $(this).toggleClass("gridactive");

    var selectedProducts = $(".bundle-sec .bundle-grid.gridactive").find(
      "[product-price]"
    );

    var totalPrice = 0;

    selectedProducts.each(function () {
      var product_price = $(this).attr("product-price");
      var product_pricewithoutdollar = parseFloat(
        product_price.replace("$", "")
      );

      totalPrice += product_pricewithoutdollar;
    });

    setTimeout(function () {
      $("span.price_cwithoutut").text("$" + totalPrice.toFixed(2));
    }, 500);

    var selectedProductsdel = $(".bundle-sec .bundle-grid.gridactive").find(
      "[product-delprice]"
    );
    var totalPricedel = 0;

    selectedProductsdel.each(function () {
      var product_pricedel = $(this).attr("product-delprice");
      var product_pricewithoutdollardel = parseFloat(
        product_pricedel.replace("$", "")
      );

      totalPricedel += product_pricewithoutdollardel;
    });


    setTimeout(function () {
      $(".total_price_bundle_csrty span.compare_price_cut del").text(
        "$" + totalPricedel.toFixed(2)
      );
    }, 500);
  });

  $(document).on("click", "a.addto_cart_bundle_csrt:not('.bundle-quick-view')", function () {
    let bundleIds = [];
    $(".bundle-sec .bundle-grid.gridactive")
      .find("[bundle-id]")
      .each(function () {
        let bundle_id = $(this).attr("bundle-id");
        bundleIds.push(bundle_id);
      });

    function addToCart(bundle_id) {
      if($(`[bundle-id='${bundle_id}']`).closest('.bundle-grid-item').find('.content_icon_bundle').attr("product-quantity")){
         var quantity = Number($(`[bundle-id='${bundle_id}']`).closest('.bundle-grid-item').find('.content_icon_bundle').attr("product-quantity"));
      }else{
         var quantity = 1;
      }


      return new Promise((resolve, reject) => {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: quantity,
            id: bundle_id,
          },
          dataType: "json",
          success: function (response) {

            resolve();
          },
          error: function (error) {
            console.error("Error adding product to cart:", error);
            reject(error);
          },
        });
      });
    }

    bundleIds.reduce((promiseChain, bundle_id, index) => {
      return promiseChain.then(() => {
        if (index === bundleIds.length - 1) {
          return addToCart(bundle_id).then(() => {
            window.location.href = "/cart";
          });
        } else {
          return addToCart(bundle_id);
        }
      });
    }, Promise.resolve());
  });

  $(
    ".demo-slider-inner li.item .arrivals_main .arrivals_info .product_info .variant_csrty label"
  ).on("click", function () {
    $(this).siblings().removeClass("activeCOLOR");
    $(this).addClass("activeCOLOR");
  });

  $(".productitem--swatches-container label").on("click", function () {
    $(".productitem--swatches-container label").removeClass("selected");
    $(".productitem--swatches-container label").addClass("not-selected");
    $(this).addClass("selected");
    $(this).removeClass("not-selected");
  });
  $(".accessiors_btn_add").on("click", function () {
    var idvarinat = $(
      "form.productitem--swatches-container label.selected input"
    ).attr("id-variant");

    const quantity = 1;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: idvarinat,
      },
      dataType: "json",
      success: function (response) {

        window.location.href = "/cart";
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  $(".butn_quickadd").click(function () {
    $(this).addClass("adding");
    var variant_id = $(this).attr("data-variant-id");

    const quantity = 1;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: variant_id,
      },
      dataType: "json",
      success: function (response) {

        window.location.href = "/cart";
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  $(".quickshop-button").click(function () {
    $(".productgrid--item").removeClass("activeli");
    $(".quick_innfoormtion").removeClass("closed");
    $(this).closest(".productgrid--item").addClass("activeli");
    $("body").addClass("quick_active");
  });

  $(".modal-close").click(function () {
    $(".quick_innfoormtion").addClass("closed");
    $("body").removeClass("quick_active");
  });

  $(".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item").click(
    function () {
      $(this).siblings().removeClass("mobileactive");
      $(this).siblings().addClass("mobileinactive");
      $(this).addClass("mobileactive");
      $(this).removeClass("mobileinactive");
    }
  );

  $("a.mobile-nav-close").on("click", function () {
    $(
      ".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item"
    ).removeClass("mobileinactive");
    $(
      ".mobile-nav-content ul.navmenu.navmenu-depth-1 li.navmenu-item"
    ).removeClass("mobileactive");
  });

  $(
    ".nav_center_nikki nav.site-navigation .navmenu li.navmenu-meganav__item-parent"
  ).hover(
    function () {
      $(this).addClass("hover-class");
      $(".navmenu li.navmenu-meganav__item-parent")
        .not($(this))
        .addClass("other-class");
    },
    function () {
      $(this).removeClass("hover-class");
      $(".navmenu li.navmenu-meganav__item-parent")
        .not($(this))
        .removeClass("other-class");
    }
  );

  $("fieldset.for_mobile_csrty .for_mobile_option").click(function () {
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .removeClass("active");
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .prev(".options-selection__option-values")
      .removeClass("on_active");
    $(this).toggleClass("active");
    $(".custom-model-main").toggleClass("active");
    $(this).prev(".options-selection__option-values").toggleClass("on_active");
    if ($("body").find("div.on_active").length > 0) {
      $(".custom-model-main.model-open").addClass("active");
      $("body").addClass("unique_scroll");
    } else {
      $(".custom-model-main.model-open").removeClass("active");
      $("body").removeClass("unique_scroll");
    }
  });
  $(".for_mobile_option.val__frame .icon_mobile").on("click", function () {
    if ($(this).hasClass("frame_active")) {
      $(
        ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt.on_active"
      ).addClass("farmeactive");
    } else {
      $(
        ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt.on_active"
      ).removeClass("farmeactive");
      $(".for_mobile_option.val__frame").trigger("click");

    }
  });
  $(".for_mobile_option.val__frame span.icon_mobile").on("click", function () {
    $(this).toggleClass("frame_active");
    $(".custom-model-main.model-open").toggleClass("frame_active_values");

    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .removeClass("active");
    $("fieldset.for_mobile_csrty .for_mobile_option")
      .not(this)
      .prev(".options-selection__option-values")
      .removeClass("on_active");

    if ($("body").find("div.on_active").length > 0) {
      $(".custom-model-main.model-open").addClass("active");
    } else {
      $(".custom-model-main.model-open").removeClass("active");
    }
  });


  const changeActiveImages = () => {
  $(".product-change-image").each(function () {
        const parentElement = $(this);
        var variantId = parentElement.find(".variant-selection.normal_form").attr("variant");

        const variantImage = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr("data-variant-image");
        const variantPrice = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr("data-variant-price");
        const variantAvailable = parentElement.find(`.variant-selection.normal_form select option[value="${variantId}"]`).attr('disabled') ? true : false;


        variantAvailable ? $('.product-form--atc-button').addClass('popup') : $('.product-form--atc-button').removeClass('popup')
        variantAvailable ? $('.product-form--atc-button .atc-button--text').text('Contact Us') : $('.product-form--atc-button .atc-button--text').text('Add to Cart')
        const blocks = document.querySelectorAll('.product-form__action-wrapper-main-text');
        let found = false;

        blocks.forEach(block => {
          const shipId = block.getAttribute('data-variant-ship-id');
          if (shipId === variantId) {
            block.style.display = 'flex';
            found = true;
          } else {
            block.style.display = 'none';
          }
        });

         if (!found && blocks.length > 0) {
          blocks.forEach((block, index) => {
            block.style.display = index === 0 ? 'flex' : 'none';
          });
       }


        const selectedMedia = parentElement.find(`.gallery-navigation--scroller img[src="${variantImage}"]`).closest(".cst-media-sec");


        if (variantPrice) {
          const priceNode = document.querySelector('.product-pricing .price__current .money');
          if (priceNode) {
            priceNode.innerHTML = `$${(variantPrice / 100).toFixed(2)}`;
          }
        }

        if (selectedMedia.length) {
          const allMedia = parentElement.find(".gallery-navigation--scroller .cst-media-sec");
          allMedia.hide();

          selectedMedia.show();

          let currentElement = selectedMedia;
          const collectionNode = document.querySelector('[data-collection]');
          const imageCountNode = document.querySelector('[data-image-count]');
          var showImages =
            collectionNode && collectionNode.getAttribute('data-collection') === 'Accessories'
              ? 3
              : 6;

          if (imageCountNode) {
            const configuredImageCount = parseInt(
              imageCountNode.getAttribute('data-image-count'),
              10
            );

            if (!Number.isNaN(configuredImageCount) && configuredImageCount > 0) {
              showImages = configuredImageCount;
            }
          }

          for (let i = 1; i < showImages; i++) {
            currentElement = currentElement.next();
            if (currentElement.length) {
              currentElement.show();
            } else {
              break;
            }
          }


        }

  });
};


  function normalizeMobileProductImageUrl(src) {
    if (!src) return "";

    try {
      const url = new URL(src, window.location.origin);
      return decodeURIComponent(url.pathname);
    } catch (error) {
      return String(src)
        .split("?")[0]
        .replace(/^https?:\/\/[^/]+/, "")
        .replace(/^\/\/[^/]+/, "");
    }
  }

  function mobileProductImagesMatch(firstSrc, secondSrc) {
    const first = normalizeMobileProductImageUrl(firstSrc);
    const second = normalizeMobileProductImageUrl(secondSrc);

    if (!first || !second) return false;
    if (first === second) return true;

    const firstFilename = first.split("/").pop();
    const secondFilename = second.split("/").pop();

    return Boolean(
      firstFilename &&
      secondFilename &&
      firstFilename === secondFilename
    );
  }

  function getMobileGalleryImageCount($container) {
    let showImages = 5;

    const collectionElement =
      $container.find("[data-collection]").get(0) ||
      document.querySelector("[data-collection]");

    if (
      collectionElement &&
      collectionElement.getAttribute("data-collection") === "Accessories"
    ) {
      showImages = 3;
    }

    const imageCountElement =
      $container.find("[data-image-count]").get(0) ||
      document.querySelector("[data-image-count]");

    if (imageCountElement) {
      const customImageCount = parseInt(
        imageCountElement.getAttribute("data-image-count"),
        10
      );

      if (!Number.isNaN(customImageCount) && customImageCount > 0) {
        showImages = customImageCount;
      }
    }

    return showImages;
  }

  function getMainProductChangeImage($container, triggerElement) {
    let $productChangeImage = $();

    if (triggerElement) {
      const $trigger = $(triggerElement);

      $productChangeImage = $trigger.closest(".product-change-image");

      if (!$productChangeImage.length) {
        const $triggerSection = $trigger.closest(".product--section");

        if ($triggerSection.length) {
          $productChangeImage = $triggerSection
            .find(".product-change-image")
            .filter(function () {
              return $(this).closest(".quick_innfoormtion").length === 0;
            })
            .first();
        }
      }
    }

    if (!$productChangeImage.length) {
      $productChangeImage = $container
        .find(".product-change-image")
        .filter(function () {
          return $(this).closest(".quick_innfoormtion").length === 0;
        })
        .first();
    }

    if (!$productChangeImage.length) {
      const $section = $container.closest(".product--section");

      if ($section.length) {
        $productChangeImage = $section
          .find(".product-change-image")
          .filter(function () {
            return $(this).closest(".quick_innfoormtion").length === 0;
          })
          .first();
      }
    }

    if (!$productChangeImage.length) {
      $productChangeImage = $(".product-change-image")
        .filter(function () {
          return (
            $(this).closest(".quick_innfoormtion").length === 0 &&
            $(this).is(":visible")
          );
        })
        .first();
    }

    if (!$productChangeImage.length) {
      $productChangeImage = $(".product-change-image")
        .filter(function () {
          return $(this).closest(".quick_innfoormtion").length === 0;
        })
        .first();
    }

    if (!$productChangeImage.length) {
      $productChangeImage = $(".product-change-image").first();
    }

    return $productChangeImage;
  }

  function getMobileVariantData($container, triggerElement) {
    const $productChangeImage = getMainProductChangeImage(
      $container,
      triggerElement
    );

    if (!$productChangeImage.length) return null;

    let $variantSelection = $productChangeImage
      .find(".variant-selection.normal_form")
      .first();

    if (!$variantSelection.length && triggerElement) {
      $variantSelection = $(triggerElement)
        .closest(".variant-selection.normal_form");
    }

    if (!$variantSelection.length) return null;

    const variantId = $variantSelection.attr("variant");
    if (!variantId) return null;

    const $variantOption = $variantSelection
      .find(`select option[value="${variantId}"]`)
      .first();

    if (!$variantOption.length) return null;

    const variantImage = $variantOption.attr("data-variant-image");
    if (!variantImage) return null;

    return {
      $productChangeImage,
      $variantSelection,
      variantId,
      variantImage,
    };
  }

  function syncMobileProductThumbnails(sliderElement) {
    if (!sliderElement || !sliderElement.swiper) return;

    const swiper = sliderElement.swiper;
    const $slider = $(sliderElement);
    const $thumbnails = $slider.find(".mobile-product-thumbnail");
    const activeIndex = swiper.activeIndex || 0;

    $thumbnails
      .removeClass("is-active")
      .attr("aria-current", "false");

    const $activeThumbnail = $thumbnails.eq(activeIndex);

    $activeThumbnail
      .addClass("is-active")
      .attr("aria-current", "true");

    if ($activeThumbnail.length) {
      const thumbnailElement = $activeThumbnail.get(0);
      const stripElement = $slider.find(".mobile-product-thumbnails").get(0);

      if (thumbnailElement && stripElement) {
        const thumbLeft = thumbnailElement.offsetLeft;
        const thumbRight = thumbLeft + thumbnailElement.offsetWidth;
        const visibleLeft = stripElement.scrollLeft;
        const visibleRight = visibleLeft + stripElement.clientWidth;

        if (thumbLeft < visibleLeft || thumbRight > visibleRight) {
          stripElement.scrollTo({
            left: Math.max(0, thumbLeft - 12),
            behavior: "smooth",
          });
        }
      }
    }
  }

  function bindMobileProductThumbnailEvents(sliderElement) {
    if (!sliderElement || !sliderElement.swiper) return;

    const swiper = sliderElement.swiper;
    const $slider = $(sliderElement);
    const $thumbnailStrip = $slider.find(".mobile-product-thumbnails");

    if ($thumbnailStrip.length && !$thumbnailStrip.data("urbanica-bound")) {
      $thumbnailStrip.data("urbanica-bound", true);

      $thumbnailStrip.on(
        "click.urbanicaMobileThumbs",
        ".mobile-product-thumbnail",
        function (event) {
          event.preventDefault();

          const targetIndex = parseInt(
            $(this).attr("data-mobile-thumbnail"),
            10
          );

          if (Number.isNaN(targetIndex)) return;

          swiper.slideTo(targetIndex, 300);
        }
      );
    }

    if (!swiper.__urbanicaMobileThumbSyncBound) {
      swiper.__urbanicaMobileThumbSyncBound = true;

      swiper.on("slideChange", function () {
        syncMobileProductThumbnails(sliderElement);
      });
    }
  }

  function initMobileProductSliders() {
    $(".thumnailslider_for_mobile").each(function () {
      const sliderElement = this;

      if (!sliderElement.swiper) {
        new Swiper(sliderElement, {
          pagination: {
            el: sliderElement.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      }

      bindMobileProductThumbnailEvents(sliderElement);
      syncMobileProductThumbnails(sliderElement);
    });
  }

  function createMobileProductSlide(sourceImage) {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";

    const inner = document.createElement("div");
    inner.className = "demo-slider-inner_thumnail";

    const image = sourceImage.cloneNode(true);

    if (!image.getAttribute("src") && sourceImage.currentSrc) {
      image.setAttribute("src", sourceImage.currentSrc);
    }

    inner.appendChild(image);
    slide.appendChild(inner);

    return slide;
  }

  function createMobileProductThumbnail(sourceImage, index) {
    const button = document.createElement("button");
    button.className = "mobile-product-thumbnail";
    button.type = "button";
    button.setAttribute("data-mobile-thumbnail", String(index));
    button.setAttribute(
      "aria-label",
      `View product image ${index + 1}`
    );
    button.setAttribute("aria-current", index === 0 ? "true" : "false");

    if (index === 0) {
      button.classList.add("is-active");
    }

    const image = sourceImage.cloneNode(true);

    if (!image.getAttribute("src") && sourceImage.currentSrc) {
      image.setAttribute("src", sourceImage.currentSrc);
    }

    image.setAttribute("width", "64");
    image.setAttribute("height", "64");
    image.setAttribute("loading", "lazy");

    button.appendChild(image);

    return button;
  }

  const changeActiveMobileImages = (triggerElement) => {
    initMobileProductSliders();

    $(".product__container").each(function () {
      const $container = $(this);
      const sliderElement = $container
        .find(".thumnailslider_for_mobile")
        .get(0);

      if (!sliderElement || !sliderElement.swiper) return;

      if (triggerElement) {
        const $triggerContainer = $(triggerElement).closest(
          ".product__container"
        );

        if (
          $triggerContainer.length &&
          $triggerContainer.get(0) !== $container.get(0)
        ) {
          return;
        }
      }

      const variantData = getMobileVariantData(
        $container,
        triggerElement
      );

      if (!variantData) {

        return;
      }

      const {
        $productChangeImage,
        variantId,
        variantImage,
      } = variantData;

      const $allSourceMedia = $productChangeImage.find(
        ".gallery-navigation--scroller .cst-media-sec"
      );

      if (!$allSourceMedia.length) {

        return;
      }

      let startIndex = -1;

      $allSourceMedia.each(function (index) {
        const sourceImage = $(this).find("img").first().get(0);

        if (!sourceImage) return;

        const sourceSrc =
          sourceImage.getAttribute("src") || sourceImage.currentSrc;

        if (mobileProductImagesMatch(sourceSrc, variantImage)) {
          startIndex = index;
          return false;
        }
      });


      if (startIndex === -1) {

        return;
      }

      const showImages = getMobileGalleryImageCount($container);
      const sourceImages = [];

      for (
        let index = startIndex;
        index < $allSourceMedia.length && sourceImages.length < showImages;
        index++
      ) {
        const sourceImage = $allSourceMedia
          .eq(index)
          .find("img")
          .first()
          .get(0);

        if (sourceImage) {
          sourceImages.push(sourceImage);
        }
      }

      if (!sourceImages.length) {

        return;
      }

      const swiper = sliderElement.swiper;
      const $slider = $(sliderElement);
      const thumbnailStrip = $slider
        .find(".mobile-product-thumbnails")
        .get(0);

      const slides = sourceImages.map(function (sourceImage) {
        return createMobileProductSlide(sourceImage);
      });

      swiper.removeAllSlides();
      swiper.appendSlide(slides);
      swiper.update();

      if (swiper.pagination) {
        if (typeof swiper.pagination.render === "function") {
          swiper.pagination.render();
        }

        if (typeof swiper.pagination.update === "function") {
          swiper.pagination.update();
        }
      }

      if (thumbnailStrip) {
        thumbnailStrip.innerHTML = "";

        sourceImages.forEach(function (sourceImage, index) {
          thumbnailStrip.appendChild(
            createMobileProductThumbnail(sourceImage, index)
          );
        });
      }

      swiper.slideTo(0, 0, false);
      syncMobileProductThumbnails(sliderElement);


    });
  };

  initMobileProductSliders();

  $(document).ready(function () {

   $('.product--section .quick_innfoormtion').each(function () {
    $(this).find('.options-selection__option-values').each(function () {
      const $firstAvailable = $(this).find('input[type="radio"]:enabled').first();
      if ($firstAvailable.length) {
        $firstAvailable.prop('checked', true).trigger('change');
      }
    });
  });


    changeActiveImages();
    setTimeout(function () {
      changeActiveMobileImages();
    }, 100);

  })
  $("label.options-selection__option-value-label.Color").on(
    "click",
    function () {

      setTimeout(function () {
        var color = $(".for_mobile_option.val__Color")
          .prev(
            ".options-selection__option-values.unique_csrtColor.for.mobile_csdrt"
          )
          .attr("data-variant-option-chosen-value");

        $(".for_mobile_option.val__Color span.color_seleted label").css(
          "background-color",
          color
        );
        $(".for_mobile_option.val__Color span.color_seleted label").text(color);


      }, 500);
    }
  );


$(document).on("change", "[data-variant-option-value]", function () {
  const changedVariantOption = this;

  setTimeout(function () {
    changeActiveImages();
    changeActiveMobileImages(changedVariantOption);
  }, 350);
});


  $("label.options-selection__option-value-label.frame").on(
    "click",
    function () {

      setTimeout(function () {
        var frame = $(".for_mobile_option.val__frame")
          .prev(
            ".options-selection__option-values.unique_csrtframe.for.mobile_csdrt"
          )
          .attr("data-variant-option-chosen-value");

        $(".for_mobile_option.val__frame span.color_seleted label").css(
          "background-color",
          frame
        );
        $(".for_mobile_option.val__frame span.color_seleted label").text(frame);

      }, 500);
    }
  );

  $("button.site-header-menu-toggle.test_68").on("click", function () {
    $(".mobile-nav-panel").addClass("allow-scroll-while-locked");
    $("html.js.has-touch").addClass("scroll-locked");
    $("div#site-mobile-nav").attr("data-open", "true");
    $(".mobile-nav-panel").attr("data-animation-state", "open");
  });
  $("a.mobile-nav-close").on("click", function () {
    $(".mobile-nav-panel").removeClass("allow-scroll-while-locked");
    $("html.js.has-touch").removeClass("scroll-locked");
    $("div#site-mobile-nav").attr("data-open", "false");
    $(".mobile-nav-panel").attr("data-animation-state", "closed");
  });
  $(".currentprice_is_csrty p:last-child").hide();
  $(".details-wrapper details summary").on("click", function () {

    if ($(".details-wrapper details").attr("open") !== undefined) {
      var screenWidth = $(window).width();


      $(".product-form__action-wrapper.own_product").removeClass("disable");
      if (screenWidth < 991) {

        $("#stop_scroll").css("margin-top", "0px");
      } else {
        $("#stop_scroll").css("margin-top", "0px");
      }
    } else {
      var screenWidth = $(window).width();


      $(".product-form__action-wrapper.own_product").addClass("disable");
      if (screenWidth < 991) {

        $("#stop_scroll").css("margin-top", "0px");
      } else {

        $("#stop_scroll").css("margin-top", "160px");
      }
    }
  });

  $(".add_icon").on("click", function () {
    const container = $(this).closest(".product_infor_add_on");
    const addIcon = container.find(".add_icon");
    const addDone = container.find(".add_done");

    addIcon.removeClass("Add_icon_active").show();
    $(".add_done").removeClass("adddone_active");

    $(this).addClass("Add_icon_active").hide();
    addDone.addClass("adddone_active");

    addProduct(container);
  });

  $("span.removed").on("click", function () {
    const container = $(this).closest(".product_infor_add_on");
    const addIcon = container.find(".add_icon");
    const addDone = container.find(".add_done");

    addIcon.show().removeClass("Add_icon_active");
    addDone.removeClass("adddone_active");

    removeProduct(container);
  });


  function addProduct(container) {
  const productid = container.find("input.product_Addon").attr("variant-id");
  const quantity = 1;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: quantity,
      id: productid,
    },
    dataType: "json",
    success: function (response) {

    },
    error: function (error) {
      console.error("Error adding product to cart:", error);
    },
  });
}

function removeProduct(container) {
  const productid = container.find("input.product_Addon").attr("variant-id");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      quantity: 0,
      id: productid,
    },
    success: function (cart) {

    },
    error: function (error) {
      console.error("Error removing product from cart:", error);
    },
  });
}

  $(document).ready(function () {
  if ($("body").hasClass("template-product")) {
    const quantityInput = $("input.quantity-selector__input");
    const minusButton = $(".quantity-selector__button--minus");

    function toggleMinusButtonState(quantity) {
      if (quantity > 1) {
        minusButton.closest(".quantity-selector__button-wrapper").removeClass("quantity-selector__button-wrapper--disabled");
      } else {
        minusButton.closest(".quantity-selector__button-wrapper").addClass("quantity-selector__button-wrapper--disabled");
      }
    }

    $(".quantity-selector__button--plus").on("click", function () {
      let currentQuantity = parseInt(quantityInput.val()) || 1;
      currentQuantity++;
      quantityInput.val(currentQuantity).trigger("input");
      toggleMinusButtonState(currentQuantity);
    });

    $(".quantity-selector__button--minus").on("click", function () {
      let currentQuantity = parseInt(quantityInput.val()) || 1;
      if (currentQuantity > 1) {
        currentQuantity--;
        quantityInput.val(currentQuantity).trigger("input");
        toggleMinusButtonState(currentQuantity);
      }
    });

    toggleMinusButtonState(parseInt(quantityInput.val()) || 1);
  }
});

  $(".Click-here").on("click", function () {
    $(".custom-model-main").addClass("model-open");
  });
  $(".close-btn, .bg-overlay").click(function () {
    $(".custom-model-main").removeClass("model-open");
  });

  function isCollectionSliderVisible() {
    var collectionSlider = $(".Collection_slider_unique").first();

    if (!collectionSlider.length) {
      return false;
    }

    var sliderOffset = collectionSlider.offset();

    if (!sliderOffset) {
      return false;
    }

    var scrollPosition = $(window).scrollTop();
    return sliderOffset.top < scrollPosition + 1000;
  }

  function showAlerts() {
    if (isCollectionSliderVisible()) {
      $(".Click-here").trigger("click");
    } else {
      $(".close-btn").trigger("click");
    }
  }

  if ($(".Collection_slider_unique").length) {
    $(window).on("scroll.collectionAlerts", showAlerts);
    showAlerts();
  }

    function isMobile() {
    return window.innerWidth <= 1024;
  }

  if (isMobile()) {


    $(".product-main").attr("id", "");
    $(".product-details").attr("id", "");
  }

  $(".product-form__action-wrapper.own_product");
});

document.addEventListener("DOMContentLoaded", function () {
  const priceElement = document.querySelector(".price_csrty .money");
  const quantityInput = document.querySelector("input.quantity-selector__input");
  const variantSelector = $(".variant-selection.normal_form")[1];

  if (!priceElement || !variantSelector || !quantityInput) {
    return;
  }

  function updatePrice() {

    let variantId;
    let selectedOption = null;

    if (typeof jQuery !== "undefined") {
      variantId = variantSelector.getAttribute("variant");
      selectedOption = $(`.variant-selection.normal_form select option[value="${variantId}"]`).get(0);
    } else {
      const variantElement = document.querySelector(".variant-selection.normal_form");
      variantId = variantElement ? variantElement.getAttribute("variant") : null;
      selectedOption = variantElement
        ? variantElement.querySelector(`select option[value="${variantId}"]`)
        : null;
    }

    if (!selectedOption) {
      return;
    }

    const optionText = selectedOption.textContent || selectedOption.innerText || "";

    const priceMatch = optionText.match(/\$([\d,\.]+)/);
    let variantPrice = priceMatch ? parseFloat(priceMatch[1].replace(',', '')) : null;


    if (isNaN(variantPrice)) {
      return;
    }

    let quantity = parseInt(quantityInput.value) || 1;

    let finalPrice = variantPrice * quantity;

    let discount = getBulkDiscount(quantity, variantPrice);

finalPrice -= discount;

const formattedFinalPrice = finalPrice.toFixed(2);
const formattedDiscount = discount.toFixed(2);

priceElement.innerHTML = `$${formattedFinalPrice}`;

if (discount > 0) {
  let discountElement = priceElement.nextElementSibling;

  if (discountElement && discountElement.classList.contains("save")) {
    discountElement.innerHTML = ` save $${formattedDiscount}`;
  } else {
    discountElement = document.createElement("span");
    discountElement.classList.add("save");
    discountElement.innerHTML = ` save $${formattedDiscount}`;
    priceElement.after(discountElement);
  }
} else {
  const saveElement = document.querySelector('.currentprice_is_csrty .save');
  if (saveElement) {
    saveElement.remove();
  }
}


  }

  function getBulkDiscount(quantity, basePrice) {
    const table = document.querySelector('.bulk-discounts-dropdown__table');

    if (table) {
      table.classList.remove('q5', 'q10', 'q20');
    }

    if (quantity >= 20) {
      if (table) table.classList.add('q20');
      return basePrice * 0.20 * quantity;
    }

    if (quantity >= 10) {
      if (table) table.classList.add('q10');
      return basePrice * 0.10 * quantity;
    }

    if (quantity >= 5) {
      if (table) table.classList.add('q5');
      return basePrice * 0.05 * quantity;
    }

    return 0;
  }


    variantSelector.addEventListener("change", updatePrice);
  quantityInput.addEventListener("input", updatePrice);

  document.querySelectorAll(".quantity-selector__button").forEach(button => {
    button.addEventListener("click", function () {
      setTimeout(() => {
        updatePrice();
      }, 100);
    });
  });

  updatePrice();
});

/* Bundles product preview: pointer and keyboard navigation. */
(function(){'use strict';if(window.__urbanicaBundlesPreview)return;window.__urbanicaBundlesPreview=true;function previewBundle(link){var root=link.closest('[data-bundles-menu]');if(!root)return;root.querySelectorAll('[data-bundle-product]').forEach(function(card){card.hidden=card.dataset.bundleProduct!==link.dataset.bundlePreview;});}document.addEventListener('pointerover',function(e){var link=e.target.closest('[data-bundle-preview]');if(link)previewBundle(link);});document.addEventListener('focusin',function(e){var link=e.target.closest('[data-bundle-preview]');if(link)previewBundle(link);});})();

(function(){'use strict';if(window.__ucCards20)return;window.__ucCards20=true;function moneyText(value){var text=String(value||'');for(var pass=0;pass<3;pass++){var parsed=new DOMParser().parseFromString(text,'text/html').body.textContent||'';if(parsed===text)break;text=parsed;}return text.trim();}document.addEventListener('click',function(e){var sw=e.target.closest('[data-uc-swatch]');if(!sw)return;var card=sw.closest('[data-uc-card]');if(!card)return;e.preventDefault();e.stopPropagation();card.querySelectorAll('[data-uc-swatch]').forEach(function(b){b.setAttribute('aria-pressed',String(b===sw));});var image=card.querySelector('.uc-card__image');if(image&&sw.dataset.image){image.src=sw.dataset.image;image.removeAttribute('srcset');}var link=card.querySelector('[data-uc-link]');if(link&&sw.dataset.url)link.href=sw.dataset.url;var price=card.querySelector('.urbanica-product-pricing__current');if(price&&sw.dataset.price)price.textContent=moneyText(sw.dataset.price);var compare=card.querySelector('.urbanica-product-pricing__compare');if(sw.dataset.compare){if(!compare){compare=document.createElement('s');compare.className='urbanica-product-pricing__compare money';price.parentNode.insertBefore(compare,price);}compare.textContent=moneyText(sw.dataset.compare);compare.hidden=false;}else if(compare){compare.hidden=true;}});})();
(function(){'use strict';function fitPopups(){document.querySelectorAll('.image_slideshow .slick-active label.on > .content_csrtyu, .for-teams-case__hotspot[open] > .for-teams-case__tooltip').forEach(function(popup){if(!popup.querySelector('[data-uc-card]'))return;popup.style.setProperty('--uc-popup-shift','0px');var rect=popup.getBoundingClientRect(),edge=12,shift=0;if(rect.left<edge)shift=edge-rect.left;else if(rect.right>document.documentElement.clientWidth-edge)shift=document.documentElement.clientWidth-edge-rect.right;popup.style.setProperty('--uc-popup-shift',shift+'px');});}document.addEventListener('click',function(e){if(e.target.closest('.image_slideshow label, .for-teams-case__hotspot'))requestAnimationFrame(fitPopups);});document.addEventListener('toggle',function(e){if(e.target.matches('.for-teams-case__hotspot'))requestAnimationFrame(fitPopups);},true);window.addEventListener('resize',function(){requestAnimationFrame(fitPopups);});if(window.jQuery)window.jQuery(document).on('afterChange reInit breakpoint','.multiple-items_image',function(){requestAnimationFrame(fitPopups);});})();

/* Close the Header Bundles disclosure when its pointer/focus leaves. */
(function(){'use strict';if(window.__urbanicaBundlesDismiss)return;window.__urbanicaBundlesDismiss=true;var timers=new WeakMap();function owner(node){return node&&node.closest?node.closest('.navmenu-id-bundles'):null;}function isBundle(parent){return parent&&parent.querySelector('[data-bundles-menu]');}function close(parent){if(!isBundle(parent))return;var details=parent.querySelector(':scope > details');if(details){details.open=false;var summary=details.querySelector(':scope > summary');if(summary)summary.setAttribute('aria-expanded','false');}parent.classList.remove('hover-class');document.querySelectorAll('.navmenu-item.other-class').forEach(function(item){item.classList.remove('other-class');});}function cancel(parent){var timer=timers.get(parent);if(timer)clearTimeout(timer);}document.addEventListener('pointerover',function(e){var parent=owner(e.target);if(isBundle(parent))cancel(parent);});document.addEventListener('pointerout',function(e){var parent=owner(e.target);if(e.pointerType==='touch'||!isBundle(parent)||(e.relatedTarget&&parent.contains(e.relatedTarget)))return;cancel(parent);timers.set(parent,setTimeout(function(){close(parent);},140));});document.addEventListener('focusout',function(e){var parent=owner(e.target);if(isBundle(parent)&&(!e.relatedTarget||!parent.contains(e.relatedTarget)))close(parent);});document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;document.querySelectorAll('.navmenu-id-bundles').forEach(close);});document.addEventListener('click',function(e){document.querySelectorAll('.navmenu-id-bundles').forEach(function(parent){if(!parent.contains(e.target))close(parent);});});})();
